
import { Signal } from "signals";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import { Services } from "slotworks/services/services";
import { SoundEvent } from "slotworks/services/sound/sound-events";

export default class ToggleElement {

    public onChanged: Signal;

    private onButton: FlexiButton;
    private offButton: FlexiButton;

    private checked: boolean;

    constructor() {
        this.onChanged = new Signal();
    }

    public addButton(button: FlexiButton, buttonState: "on" | "off") {
        if (buttonState === "on" && !this.onButton) {
            this.onButton = button;
            this.onButton.on(ButtonEvent.CLICK, this.onButtonHandler);
        } else if (buttonState === "off" && !this.offButton) {
            this.offButton = button;
            this.offButton.on(ButtonEvent.CLICK, this.offButtonHandler);
        }

        this.setChecked(true);
    }

    public setChecked(on: boolean) {
        if (this.onButton) {
            this.onButton.setVisible(on);
        }

        if (this.offButton) {
            this.offButton.setVisible(!on);
        }

        this.checked = on;
    }

    public getChecked() {
        return this.checked;
    }

    public setEnabled(enabled: boolean) {
        if (this.onButton) {
            this.onButton.setEnabled(enabled);
        }

        if (this.offButton) {
            this.offButton.setEnabled(enabled);
        }
    }

    public setVisible(visible: boolean) {

        if (visible) {
            if (this.onButton) {
                this.onButton.setVisible(this.checked);
            }

            if (this.offButton) {
                this.offButton.setVisible(!this.checked);
            }
        } else {
            if (this.onButton) {
                this.onButton.setVisible(false);
            }

            if (this.offButton) {
                this.offButton.setVisible(false);
            }
        }
    }

    public destroy() {
        if (this.onButton) {
            this.onButton.off(ButtonEvent.CLICK, this.onButtonHandler);
            this.onButton.destroy();
            this.onButton = null;
        }

        if (this.offButton) {
            this.offButton.off(ButtonEvent.CLICK, this.onButtonHandler);
            this.offButton.destroy();
            this.offButton = null;
        }

        this.onChanged.removeAll();
    }

    private onButtonHandler = () => {
        this.setChecked(false);

        this.onChanged.dispatch(true);

        Services.sound.event(SoundEvent.toggle_on_press);
    }

    private offButtonHandler = () => {
        this.setChecked(true);

        this.onChanged.dispatch(false);

        Services.sound.event(SoundEvent.toggle_off_press);
    }

}
